import React from 'react';
import type { DepositoPerformance as DepositoPerformanceType } from '../../types/checkin';
import { DashboardCard } from './DashboardCard';
import { Card, CardContent, Grid, Typography, Box, Chip } from '@mui/material';
import { BoxProps } from '@mui/material';

interface DepositoPerformanceProps extends BoxProps {
  depositos: DepositoPerformanceType[];
}

export const DepositoPerformance: React.FC<DepositoPerformanceProps> = ({ depositos, sx }) => {
  return (
    <DashboardCard
      title="Top 3 Depósitos com Maior Tempo de Faturamento"
      sx={{ ...sx, height: '100%' }} // DashboardCard ocupa altura total
    >
      <Grid
        container
        spacing={2}
        sx={{
          height: '100%',          // container ocupa toda altura do DashboardCard
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column', // empilha verticalmente
          justifyContent: 'space-between', // distribui espaço entre os cards
        }}
      >
        {depositos.map((deposito, index) => (
          <Grid
            key={index}
            size={{ xs: 12 }}        // MUI v2 syntax
            sx={{
              flex: 1,               // cada card ocupa altura proporcional
              display: 'flex',       // para o card ocupar 100% da altura
            }}
          >
            <Card
              variant="outlined"
              sx={{
                borderLeft: '6px solid #1565c0',
                background: 'linear-gradient(to bottom right, #e3f2fd, #bbdefb)',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
              }}
            >
              <CardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '100%', // garante que o conteúdo preencha todo o card
                }}
              >
                {/* Conteúdo do card */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <Typography variant="subtitle2" fontWeight={700} color="text.primary">
                    {deposito.descricao}
                  </Typography>
                  <Chip label={`#${index + 1}`} color="primary" size="small" />
                </Box>

                <Box mb={2} p={2} bgcolor="#ffffff" borderRadius={1}>
                  <Typography variant="caption" color="text.secondary">
                    Tempo Médio de Faturamento
                  </Typography>
                  <Typography variant="h5" fontWeight={700} color="primary">
                    {deposito.tempo_medio_faturamento}
                    <Typography component="span" variant="caption" ml={1}>
                      min
                    </Typography>
                  </Typography>
                </Box>

                <Grid container spacing={2} sx={{ mt: 'auto' }}>
                  <Grid  size={{xs: 6}}>
                    <Box p={2} bgcolor="#ffffff" borderRadius={1}>
                      <Typography variant="caption" color="text.secondary">
                        Total Check-ins
                      </Typography>
                      <Typography variant="h6" fontWeight={700}>
                        {deposito.total_checkins}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid  size={{xs: 6}}>
                    <Box p={2} bgcolor="#ffffff" borderRadius={1}>
                      <Typography variant="caption" color="text.secondary">
                        Taxa Cancelamento
                      </Typography>
                      <Typography variant="h6" fontWeight={700} color="error.main">
                        {deposito.taxa_cancelamento.toFixed(1)}%
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>


    </DashboardCard>
  );
};
